// AdminSessionGuard.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../utils/constants';

const AdminSessionGuard = ({ children }) => {
  const navigate = useNavigate();

  const doLogout = async (expired) => {
    try {
      await fetch(`${API_BASE_URL}/api/admin/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (_) {}

    localStorage.removeItem('adminAuth');
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminExpiresAt');

    if (expired) {
      alert('Your admin session has expired. Please log in again.');
    }

    navigate('/admin', { replace: true });
  };

  useEffect(() => {
    const authFlag = localStorage.getItem('adminAuth');
    const expiresAtStr = localStorage.getItem('adminExpiresAt');

    // If FE doesn’t think we’re logged in, let backend handle protection
    if (authFlag !== 'true' || !expiresAtStr) {
      return;
    }

    const expiresAt = parseInt(expiresAtStr, 10);

    if (!Number.isFinite(expiresAt)) {
      console.warn('Invalid adminExpiresAt in localStorage:', expiresAtStr);
      // clear bad value and rely on backend JWT
      localStorage.removeItem('adminExpiresAt');
      return;
    }

    const now = Date.now();
    const msLeft = expiresAt - now;

    // If already expired → logout once
    if (msLeft <= 0) {
      doLogout(true);
    }
    // If NOT expired → do nothing here.
    // Backend will enforce expiry when token actually dies.
  }, []); // run once on mount

  return children;
};

export default AdminSessionGuard;
